<template>
  <div class="page-container" id="app">
    <md-app>
      <md-app-toolbar class="md-primary no-print">
        <span class="md-title">My Title</span>
      </md-app-toolbar>
      <md-app-drawer class="no-print" md-permanent="full">
        <md-toolbar class="md-transparent" md-elevation="0">
          <md-list>
            <md-list-item>
              <router-link to="/">Home</router-link>
            </md-list-item>
            <md-list-item>
              <router-link to="/about">About</router-link>
            </md-list-item>
             <md-list-item>
              <router-link to="/standards">Standards</router-link>
            </md-list-item>
            <md-divider v-if="isLoggedIn"></md-divider>            
            <UnitPlanNavigation v-if="isLoggedIn"></UnitPlanNavigation>
          </md-list>
        </md-toolbar>
      </md-app-drawer>
      <md-app-content>
        <router-view/>
      </md-app-content>
    </md-app>
  </div>
</template>
<script>
import UnitPlanNavigation from './components/UnitPlanNavigation'



export default {
	components: {
		UnitPlanNavigation
	},
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    }
  },
}
</script>
<style lang="css" scoped>

.md-drawer {
    width: 230px;
    max-width: calc(100vw - 125px);
  }


</style>


// WEBPACK FOOTER //
// src/App.vue